import React, { useEffect, useState, useRef, useMemo } from "react";
import Request from "../../../../../helpers/request";
import * as url from "../../../../../helpers/url_helper";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import ConfirmationModal from "../../../../../components/Common/ConfirmationModal";
import { useSelector } from "react-redux";
import { useSocket } from "../../../../../Utils/socket";
import { OPERATE_MQTT } from "../../../../../helpers/socketEvent";
import OtaModel from "../OtaModal";
import ChipsDataTable from "./ChipsDataTable";
import {
  DeleteIcon,
  OtaIcon,
  PingIcon,
  LogIcon,
  MqttIcon,
  MqttBoxIcon,
  AssignIcon,
} from "../../../../../assets/svg";
import DataTable from "react-data-table-component";
import OtaMultiModel from "../OtaMultiModel";
import MqttBoxModel from "../MqttBoxModel";
import AssignRoomModal from "../AssignRoomModal";
import { ActionButton } from "../../../../../components/Common/button";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import DeviceBinding from "../DeviceBinding";
import WifiModal from "../WifiModal";

export interface ChipsControlProps {
  userId: any;
  selectedPremise?: any;
}
const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");

const ChipsList = ({ userId, selectedPremise }: ChipsControlProps) => {
  const selectedRooms = useSelector(
    (state: any) => state.APIResponse.selectedRooms,
  );
  const socket: any = useSocket();
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteData, setDeleteData] = useState<any>();
  const [assignData, setAssignData] = useState<any>({});
  const [isReload, setReload] = useState<boolean>(false);
  const [isOtaModalOpen, setIsOtaModalOpen] = useState(false);
  const [isMultiOtaModalOpen, setIsMultiOtaModalOpen] = useState(false);
  const [isMqttBoxModalOpen, setIsMqttBoxModalOpen] = useState(false);
  const [isAssignRoomModalOpen, setIsAssignRoomModalOpen] = useState(false);
  const [MqttData, setMqttData] = useState<any>({});
  const [otaSlave, setOtaSlave] = useState<any>({});
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [chipData, setChipData] = useState<any[]>([]);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [selectedRowsData, setSelectedRowsData] = useState<any>({});
  const [offcanvasOpenBinding, setOffcanvasOpenBinding] = useState(false);
  const [isWifiModalOpen, setIsWifiModalOpen] = useState(false);

  const alertSlaveAirModel = useMemo(() => {
    const allowedHwVersions = ["2.0.1", "2.0.2", "2.0.3"];

    return chipData
      .filter(
        (chip: any) =>
          allowedHwVersions.includes(chip.hwVersion) &&
          chip.modelType.startsWith("Air_"),
      )
      .map((chip: any) => ({
        slave: chip.slave,
        roomName: chip.roomName,
        modelType: chip.modelType,
        hwVersion: chip.hwVersion,
      }));
  }, [chipData]);

  const columns = [
    {
      name: "Slave",
      selector: (row: any) => row.slave || "-",
      sortable: true,
      wrap: true,
    },
    {
      name: "Room",
      selector: (row: any) => row.roomName || "-",
      sortable: true,
      wrap: true,
    },
    // {
    //   name: "HW-V",
    //   selector: (row: any) => row.hwVersion || "-",
    //   sortable: true,
    //   grow: 0.5,

    //   wrap: true,
    // },
    // {
    //   name: "WI-V",
    //   selector: (row: any) => row.wifiVersion || "-",
    //   sortable: true,
    //   wrap: true,
    //   grow: 0.5,
    // },

    {
      name: "WI-V(HW-V)",
      selector: (row: any) =>
        `${row.wifiVersion || "-"} (${row.hwVersion || "-"})`,
      sortable: true,
      grow: 0.5,
      wrap: true,
    },
    {
      name: "tsw(thw)",

      selector: (row: any) => `${row.tsw || "-"} (${row.thw || "-"})`,
      sortable: true,
      wrap: true,
      grow: 0.5,
    },

    {
      name: "Model",
      selector: (row: any) => row.modelType || "-",
      grow: 0.5,
      sortable: true,
    },
    {
      name: "Status",
      selector: (row: any) => (row.isOnline ? "Online" : "Offline"),
      cell: (row: any) =>
        row.isOnline === true ? (
          <span className="font-size-11 badge-soft-success badge bg-secondary">
            online
          </span>
        ) : (
          <span className="font-size-11 badge-soft-danger badge bg-secondary">
            Offline
          </span>
        ),
      sortable: true,
      grow: 0.5,
      wrap: true,
    },

    {
      name: "Signal",
      selector: (row: any) => (row.signalStrength ? row.signalStrength : 0),
      cell: (row: any) => (
        <div>
          <span style={{ fontWeight: "bold", color: "black" }}>
            {row.signalStrength || "-"}
          </span>{" "}
          ({row.ssid || "-"})
        </div>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: "MQTT",
      cell: (row: any) => (
        <div style={{ fontWeight: "bold", color: "black" }}>
          {row?.readingCount !== "" ? row.readingCount : "-"}
        </div>
      ),
      grow: 0.5,
      sortable: true,
    },
    {
      name: "Actions",
      grow: 2,
      cell: (row: any) => (
        <div className="d-flex align-items-center" style={{ gap: "12px" }}>
          <ActionButton
            id="ViewIconButton"
            title="View"
            icon={
              <i
                className="bx bx-info-circle"
                style={{
                  fontSize: "24px",
                  color: "#667085",
                  cursor: "pointer",
                }}
              ></i>
            }
            onClick={() => handleViewClick(row)}
          />
          <ActionButton
            id="DeleteIconButton"
            title="Delete"
            icon={<DeleteIcon />}
            onClick={() => handleDeleteClick(row)}
          />
          <ActionButton
            id="PingIconButton"
            title="Ping"
            icon={<PingIcon />}
            onClick={() => handlePingClick(row)}
          />
          <ActionButton
            id="OTAIconButton"
            title="OTA"
            icon={<OtaIcon />}
            onClick={() => handleOtaClick(row)}
          />
          {/* <ActionButton
            id="LogIconButton"
            title="Log"
            icon={<LogIcon />}
             onClick={() => handleLogClick(row)}
          /> */}
          <ActionButton
            id="MQTTLogsIconButton"
            title="MQTT Logs"
            icon={<MqttIcon />}
            onClick={() => handleMQTTData(row)}
          />
          <ActionButton
            id="MQTTBoxIconButton"
            title="MQTT Box"
            icon={<MqttBoxIcon />}
            onClick={() => handleMqttBoxClick(row)}
          />
          <ActionButton
            id="AssignIconButton"
            title="Assign Room"
            icon={<AssignIcon />}
            onClick={() => handleAssignClick(row)}
          />
        </div>
      ),
    },
  ];

  const handleRefresh = () => {
    setReload((prev) => !prev);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      handleRefresh();
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  const handleMQTTData = (row: any) => {
    row?.slave
      ? window.open(`/debug-device-details/${row?.slave}`, "_blank")
      : "";
  };

  // const handleLogClick = (row: any) => {
  //   row?.slave ? navigate(`/users/profile/device/${row?.slave}`) : "";
  // };

  const handleDeleteClick = (row: any) => {
    setDeleteModalOpen(!isDeleteModalOpen);
    setDeleteData(row);
  };

  const deleteChipApiCall = () => {
    setLoading(true);
    const reqObj = {
      chipId: deleteData.id,
    };
    Request.post(url.DELETE_CHIP, reqObj)
      .then((res) => {
        // areaListApiCall()
        toast.success(res.data.msg);
        handleRefresh();
        setDeleteModalOpen(false);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        // showToast("error", err.response.data.errors[0]?.msg)
      });
  };

  const handlePingClick = (row: any) => {
    if (row !== undefined) {
      const reqObj = {
        slave: row?.slave,
        tag: `airpanel-${userInfo?.id}`,
        cmd: "PG",
      };
      socket.emit(OPERATE_MQTT, JSON.stringify(reqObj));
      handleRefresh();
      toast.success(`Ping sent to slave ${row?.slave}`);
    }
  };
  const handlePingAll = () => {
    if (selectedRows.length > 0) {
      selectedRows?.forEach((item) => {
        const reqObj = {
          slave: item.slave,
          tag: `airpanel-${userInfo?.id}`,
          cmd: "PG",
        };
        socket.emit(OPERATE_MQTT, JSON.stringify(reqObj));
      });
      handleRefresh();
      toast.success(
        `Ping successfully sent to ${selectedRows?.length} slaves.`,
      );
    }
  };
  const handleDsAll = () => {
    if (selectedRows.length > 0) {
      selectedRows?.forEach((item) => {
        const reqObj = {
          slave: item.slave,
          tag: `airpanel-${userInfo?.id}`,
          cmd: "DS",
        };
        socket.emit(OPERATE_MQTT, JSON.stringify(reqObj));
      });
      handleRefresh();
      toast.success(`DS successfully sent to ${selectedRows?.length} slaves.`);
    }
  };
  const handleUpdateWifiAll = () => {
    if (selectedRows.length > 0) {
      setIsWifiModalOpen(true);
    }
  };
  const handleDeleteAll = () => {
    if (selectedRows.length > 0) {
      toast.info("This feature will be available soon.");
    }
  };

  const handleOtaClick = (row: any) => {
    if (row !== undefined) {
      setIsOtaModalOpen(!isOtaModalOpen);
      setOtaSlave(row);
    }
  };
  const handleAssignClick = (row: any) => {
    if (row !== undefined) {
      setIsAssignRoomModalOpen(!isAssignRoomModalOpen);
      setAssignData(row);
    }
  };
  const handleMqttBoxClick = (row: any) => {
    if (row !== undefined) {
      setIsMqttBoxModalOpen(!isMqttBoxModalOpen);
      setMqttData(row);
    }
  };
  const handleOtaAll = () => {
    if (selectedRows.length > 0) {
      setIsMultiOtaModalOpen(!isMultiOtaModalOpen);
    }
  };
  const handleViewClick = (row: any) => {
    if (row !== undefined) {
      setIsViewModalOpen(!isViewModalOpen);
      setSelectedRowsData(row);
    }
  };
  const handleBinding = () => {
    setOffcanvasOpenBinding(!offcanvasOpenBinding);
  };
  const toggleRequestModel = () => {
    setIsViewModalOpen(!isViewModalOpen);
    setSelectedRowsData({});
  };

  return (
    <div>
      {alertSlaveAirModel.map((chip) => (
        <div
          key={chip.slave}
          className="alert fw-bold text-white"
          role="alert"
          style={{ backgroundColor: "#c43429" }}
        >
          Touch code update required in Slave{" "}
          <strong>
            {chip.slave} - {chip.roomName}
          </strong>
          &nbsp; (Model: {chip.modelType}, HW: {chip.hwVersion})
        </div>
      ))}

      {isDeleteModalOpen && (
        <ConfirmationModal
          headerTitle="Delete Area?"
          text="Are you sure you want to delete this Chip ? This action cannot be undone."
          buttonText="Delete"
          onClick={() => {
            deleteChipApiCall();
          }}
          cancleBtnClick={() => setDeleteModalOpen(false)}
          loading={loading}
        />
      )}
      {isOtaModalOpen && (
        <OtaModel
          headerTitle="OTA"
          otaSlave={otaSlave}
          cancleBtnClick={() => setIsOtaModalOpen(false)}
        />
      )}
      {isMultiOtaModalOpen && (
        <OtaMultiModel
          headerTitle="SELECTED OTA"
          selectedRows={selectedRows}
          cancleBtnClick={() => setIsMultiOtaModalOpen(false)}
        />
      )}
      {isMqttBoxModalOpen && (
        <MqttBoxModel
          headerTitle="MQTT Box"
          MqttData={MqttData}
          cancleBtnClick={() => setIsMqttBoxModalOpen(false)}
        />
      )}
      {isAssignRoomModalOpen && (
        <AssignRoomModal
          headerTitle="Assign Room"
          idName={"Chiplist"}
          assignData={assignData}
          handleRefresh={handleRefresh}
          cancleBtnClick={() => {
            setIsAssignRoomModalOpen(false);
            setAssignData({});
          }}
        />
      )}
      {/* {offcanvasOpenBinding && ( */}
      <DeviceBinding
        offcanvasOpen={offcanvasOpenBinding}
        closeOffcanvas={handleBinding}
        userId={userId}
        selectedPremise={selectedPremise}
      />
      {/* )} */}

      {isWifiModalOpen && (
        <WifiModal
          selectedRows={selectedRows}
          deviceType="chip"
          handleRefresh={handleRefresh}
          cancleBtnClick={() => setIsWifiModalOpen(false)}
        />
      )}

      <Modal
        isOpen={isViewModalOpen}
        role="dialog"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        // tabIndex="-1"
        toggle={toggleRequestModel}
      >
        <div className="modal-content">
          <ModalHeader style={{ justifyContent: "center" }}>
            {"View Details"} ({selectedRowsData.slave})
          </ModalHeader>
          <ModalBody>
            {selectedRowsData && (
              <div className="space-y-2">
                <p>
                  <strong>Recall :</strong>{" "}
                  {selectedRowsData.recall ? "On" : "Off"}
                </p>
                <p>
                  <strong>IR Remote :</strong>{" "}
                  {selectedRowsData.ir_set ? "On" : "Off"}
                </p>{" "}
                <p>
                  <strong>Backlit (white light) :</strong>{" "}
                  {selectedRowsData.backlit ? "On" : "Off"}
                </p>
                <p>
                  <strong>Mainlit (green light) :</strong>{" "}
                  {selectedRowsData.mainlit ? "On" : "Off"}
                </p>{" "}
              </div>
            )}
          </ModalBody>

          <ModalFooter style={{ justifyContent: "center" }}>
            <button
              className="btn btn-dark"
              type="submit"
              onClick={toggleRequestModel}
            >
              Ok
            </button>
          </ModalFooter>
        </div>
      </Modal>

      <ChipsDataTable
        apiURL={`${url.BASE_URL}${url.GET_CHIPS_LIST}`}
        title="Chip List"
        customStyles={customStyles}
        selectedRoomID={selectedRooms}
        columns={columns}
        isReload={isReload}
        expandableRows={true}
        ExpandedComponent={ExpandedComponent}
        ExpandCollapseIcon={ExpandCollapseIcon}
        idName={"Chiplist"}
        loading={loading}
        setLoading={setLoading}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        handlePingAll={handlePingAll}
        handleDsAll={handleDsAll}
        handleDeleteAll={handleDeleteAll}
        handleUpdateWifiAll={handleUpdateWifiAll}
        handleOtaAll={handleOtaAll}
        userId={userId}
        setChipData={setChipData}
        handleBinding={handleBinding}
        showBindingButton={selectedPremise?.isParent === false}
      />
    </div>
  );
};

export default ChipsList;

export const ExpandedComponent = ({ data }: { data: any }) => {
  const switchColumns: any[] = [
    {
      name: "Display Name",
      selector: (row: any) => row.displayName,
      sortable: true,
    },
    {
      name: "Button",
      selector: (row: any) => row.button,
      sortable: true,
    },
    {
      name: "Type",
      selector: (row: any) => (row.type === 1 ? "Dimmer" : "Switch"),
      sortable: true,
    },

    {
      name: "Status",
      selector: (row: any) => (row.isOn ? "true" : "false"),
      cell: (row: any) =>
        row.isOn === true ? (
          <span className="font-size-11 badge-soft-success badge bg-secondary">
            true
          </span>
        ) : (
          <span className="font-size-11 badge-soft-danger badge bg-secondary">
            false
          </span>
        ),
      sortable: true,
    },
    {
      name: "Favourite",
      selector: (row: any) => (row?.isFav ? "true" : "false"),
      cell: (row: any) =>
        row?.isFav === true ? (
          <span className="font-size-11 badge-soft-success badge bg-secondary">
            true
          </span>
        ) : (
          <span className="font-size-11 badge-soft-danger badge bg-secondary">
            false
          </span>
        ),
      sortable: true,
    },

    {
      name: "Touch Lock",
      selector: (row: any) => (row.touchLock ? "true" : "false"),
      cell: (row: any) =>
        row.touchLock === true ? (
          <span className="font-size-11 badge-soft-success badge bg-secondary">
            true
          </span>
        ) : (
          <span className="font-size-11 badge-soft-danger badge bg-secondary">
            false
          </span>
        ),
      sortable: true,
    },
    {
      name: "Widget",
      selector: (row: any) => (row.inWidget ? "true" : "false"),
      cell: (row: any) =>
        row.inWidget === true ? (
          <span className="font-size-11 badge-soft-success badge bg-secondary">
            true
          </span>
        ) : (
          <span className="font-size-11 badge-soft-danger badge bg-secondary">
            false
          </span>
        ),
      sortable: true,
    },
    {
      name: "Dimmer Value",
      selector: (row: any) => row.dimmerValue,
      sortable: true,
    },
  ];

  return (
    <div className="p-2">
      <DataTable
        columns={switchColumns}
        data={data.switches || []}
        dense
        highlightOnHover
        noDataComponent="No switches available"
        customStyles={customStyles}
      />
    </div>
  );
};

export const customStyles: any = {
  tableWrapper: {
    style: {
      minWidth: "1100px",
    },
  },
  subHeader: {
    style: {
      padding: "0px",
      margin: "0px",
    },
  },
  headRow: {
    style: {
      backgroundColor: "#EFF2F7",
      fontWeight: "bold",
      fontSize: "14px",
      borderBottom: "none",
      padding: "0px !important",
    },
  },
  headCells: {
    style: {
      padding: "0px 2px",
      margin: "0px",
    },
  },

  rows: {
    style: {
      fontSize: "14px",
      color: "#343a40",
      borderBottom: "none",
    },
  },
  cells: {
    style: {
      fontSize: "14px",
      color: "#343a40",
      borderBottom: "none",
      padding: "0px 2px !important",
    },
  },
};

export const ExpandCollapseIcon = ({ expanded }: { expanded: boolean }) => {
  return (
    <div
      className="d-flex justify-content-center align-items-center  "
      style={{ cursor: "pointer", width: "32px", height: "32px" }}
    >
      <i
        className={`bx ${
          expanded ? "bx-caret-down" : "bx-caret-right"
        } text-dark fs-5`}
      ></i>
    </div>
  );
};
